//@flow
import reducer from "./reducers";

import * as searchedGoalsOperations from "./operations";
import * as searchedGoalsSelectors from "./selectors";

export { searchedGoalsOperations, searchedGoalsSelectors };

export default reducer;
